import { useState } from "react";

/**
 * 输入相关状态 Hook
 */
const useInputState = () => {
  const [inputValue, setInputValue] = useState("");
  const [humanInput, setHumanInput] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [lastMessageType, setLastMessageType] = useState(null);
  const [projectState, setProjectState] = useState("");

  // 重置输入状态
  const resetInputState = () => {
    setInputValue("");
    setHumanInput("");
    setSelectedRoles([]);
    setLastMessageType(null);
    setProjectState("");
  };

  return {
    inputValue,
    setInputValue,
    humanInput,
    setHumanInput,
    selectedRoles,
    setSelectedRoles,
    lastMessageType,
    setLastMessageType,
    projectState,
    setProjectState,
    resetInputState,
  };
};

export default useInputState;
